import { InfoCircleIcon } from '@shipt/design-system-icons'
import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'
import { staticColors } from '@/features/shared/theme/staticColors'

type Props = {
  text: string
}

export const InfoBox = ({ text }: Props) => {
  return (
    <InfoBoxDiv>
      <IconContainer>
        <InfoBoxIcon />
      </IconContainer>
      <Body size="sm" as="span">
        {text}
      </Body>
    </InfoBoxDiv>
  )
}

const InfoBoxIcon = styled(InfoCircleIcon)`
  color: ${staticColors.blue500};
  margin-right: 1rem;
`

const InfoBoxDiv = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  background-color: ${staticColors.blue100};
  padding: 0.5rem 1rem;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
`
